(function () {
  // Banner principal: cada foto se queda quieta 5 segundos y pasa a la siguiente
  // con una transicion suave (antes era una cinta continua). Claude, oct 2026.
  const initHero = (section) => {
    if (!section || !section?.classList.contains("hero-section")) {
      return;
    }

    const slider = section.querySelector(".hero__media--slider");

    if (!slider) return;

    const sliderWrapper = slider.querySelector(".hero__media-wrapper");
    const sliderDirection = slider.dataset?.sliderDirection || "right_to_left";
    const reverseDirection = sliderDirection === "left_to_right" ? true : false;

    if (sliderWrapper) {
      sliderWrapper.style.setProperty("transition-timing-function", "ease", "important");
    }

    new Swiper(slider, {
      loop: true,
      allowTouchMove: false,
      spaceBetween: 0,
      speed: 700,
      slidesPerView: 1,
      resizeObserver: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        reverseDirection: reverseDirection,
      },
    });
  };

  initHero(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initHero(event.target);
  });
})();